export const environment = {
    apiUrl: "https://localhost:7028/api",
    encryption: {
        key: "your-encryption-key-32bytes12345",
        iv: "yourIvKey16bytes"
    },
    roles: {
        admin: "Admin"
    }
};
